<script>
    import { preventDefault } from 'svelte/legacy';

    // -- IMPORTS
    
    import { isLoadingStore } from './../../store/isLoadingStore.js';
    import { onMount } from 'svelte';
    import { toast } from '$lib/toast';
    import Button from '$lib/component/element/Button.svelte';
    import Switch from 'senselogic-flow/Switch.svelte';
    import { fetchData, addFileArrayOnObject, checkRequiredIsFilled } from '../../base';
    import { getJsonText } from 'senselogic-gist';
    import { languageArrayStore } from '$src/lib/store/languageArrayStore';
    import Input from '../../component/element/Input.svelte';
    import InputLocalizedForm from '../../component/element/InputLocalizedForm.svelte';
    import FileInput from '../../component/element/FileInput/FileInput.svelte';

    // -- VARIABLES

    /** @type {{isUploadingImage?: boolean, isUploadingHeadingImage?: boolean}} */
    let { isUploadingImage = $bindable(false), isUploadingHeadingImage = $bindable(false) } = $props();

    let form = $state();
    let hubFormData =
        $state({
            slug : '',
            name : '',
            title: '',
            number : null,
            mediaPath : null,
            isActive : false,
            latitude : '',
            longitude : '',
        });
    let hubRequiredFieldArray = ['name', 'title'];

    let hubPageData = $state({
        title : '',
        description : '',
        slug : '',
        route : '',
        typeSlug : 'hub',
        number : null,
        isActive : true,
        imageAlt : '',
        });
    let pageRequiredFieldArray = ['title', 'description'];

    let folderPath = 'hub/' + 'new/image/';
    let coverFileArray = $state([]);
    let headingFileArray = $state([]);

    let isHovered = false;
    let hubServiceArray = $state([]);

    let serviceIncludedElement = $state();

    let serviceByRequestElement = $state();

    let serviceByLocationElement = $state();

    // -- FUNCTIONS

    function setDefaultFileArray(
        )
    {
        if ( hubFormData?.mediaPath )
        {
            coverFileArray = [ hubFormData.mediaPath ];
            headingFileArray = [ hubPageData.mediaPath ];
        }
        else
        {
            coverFileArray = hubFormData.mediaPathArray ?? [];
            headingFileArray = hubPageData.mediaPathArray ?? [];
        }
    }

    // ~~

    async function loadHubServices()
    {
        let hubService =
            await fetchData(
                '/api/hub-service/get-admin',
                {
                    method: 'POST',
                    body: JSON.stringify( {} ),
                }
            );

        hubServiceArray = hubService.hubArray;
    }

    // ~~

    async function handleUpdateHubServices()
    {
        let selectedServicesByRequest = serviceByRequestElement.options;
        hubFormData.serviceRequestArray = [];

        for( let selectedService of selectedServicesByRequest )
        {
            hubFormData.serviceRequestArray.push( selectedService.value );
        }

        let selectedServicesIncluded = serviceIncludedElement.options;
        hubFormData.serviceIncludedArray = [];

        for( let selectedService of selectedServicesIncluded )
        {
            hubFormData.serviceIncludedArray.push( selectedService.value );
        }

        let selectedServicesByLocation = serviceByLocationElement.options;
        hubFormData.serviceByLocationArray = [];

        for( let selectedService of selectedServicesByLocation )
        {
            hubFormData.serviceByLocationArray.push( selectedService.value );
        }
    }

    // ~~

    function handleFormData(
        formObject,
        fileArray
        )
    {
        let newFormData = new FormData();

        formObject = addFileArrayOnObject( formObject, fileArray );

        for ( let [ key, value ] of Object.entries( formObject ) )
        {
            if ( key.includes( 'Array' ) )
            {
                newFormData.append( key, getJsonText( value ) )
            }
            else
            {
                newFormData.append( key, value )
            }
        }

        return newFormData;
    }

    // ~~

    async function handleSubmit(
        event
        )
    {
        try
        {
            $isLoadingStore = true;

            let eventTarget = event.target;

            hubPageData = {
                ...hubPageData,
                slug: hubFormData.slug,
                route: `/${ hubFormData.slug }`,
                typeSlug: 'hub',
                number: hubFormData.number,
                isActive: hubFormData.isActive,
                imageAlt: hubPageData.title
            }

            // handleUpdateHubServices();

            let hubErrorArray = checkRequiredIsFilled( hubFormData, hubRequiredFieldArray );
            let pageErrorArray = checkRequiredIsFilled( hubPageData, pageRequiredFieldArray );

            if( pageErrorArray.length > 0 || hubErrorArray.length > 0 )
            {
                return;
            }

            let formData = handleFormData( hubFormData, coverFileArray );
            let pageFormData = handleFormData(  hubPageData, headingFileArray );

            let responseHub =
                await fetchData(
                    '/api/hub/add',
                    {
                        method: 'POST',
                        body: formData,
                        credentials: 'include'
                    }
                    );

            let responsePage =
                await fetchData(
                    '/api/page/add',
                    {
                        method: 'POST',
                        body: pageFormData,
                        credentials: 'include'
                    }
                );

            if ( responsePage.error || responseHub.error )
            {
                toast(
                    {
                        variant: 'error',
                        text: 'Error on create new hub'
                    }
                    );
            }
            else
            {
                toast(
                    {
                        variant: 'success',
                        text: 'Hub created successfully'
                    }
                );
            }
        }
        catch ( error )
        {
            toast(
                {
                    variant: 'error',
                    text: 'Error on create new hub'
                }
                );
            console.error( error );
        }
        finally
        {
            $isLoadingStore = false;
            window.location.reload();
            setDefaultFileArray();
        }
    }

    // ~~

    function handleToggleHover(
        )
    {
        isHovered = !isHovered;
    }

    // ~~

    function handleUpdateHubFormLocalized(
        event
        )
    {
        hubFormData[ event.detail.name ] = JSON.stringify( event.detail.text );
    }

    // ~~

    function handleUpdatePageFormLocalized(
        event
        )
    {
        hubPageData[ event.detail.name ] = JSON.stringify( event.detail.text );
    }

    // ~~

    function customSubmit(
        event
        )
    {
        if ( form )
        {
            let fakeSubmitEvent = new Event('submit', { bubbles: true, cancelable: true } );
            form.dispatchEvent( fakeSubmitEvent );
        }
    }

    // -- STATEMENTS

    onMount(
        () =>
        {
            loadHubServices();
            setDefaultFileArray();

            window.addEventListener(
                'on-save-block',
                customSubmit
                );

            return () => {
                window.removeEventListener( 'on-save-block', customSubmit );
            }
        }
        );
</script>

<style lang="stylus">
    // -- IMPORTS

    @import '../../../constant.styl';
    @import '../../../mixin.styl';

    // -- ELEMENTS

    form
    {
        width: 100%;
        padding: 1.5rem;

        display: flex;
        flex-direction: column;
        gap: 1rem;

        +media( tablet )
        {
            padding: 1rem 2.5rem;
        }

        +media( desktop )
        {
            width: 100%;
            padding: 1.5rem 3rem;
        }
    }

    fieldset
    {
        padding: 1rem;
    }

    // -- CLASSES

    .forms-container
    {
        width: 100%;

        display: flex;
        flex-direction: column;
        gap: 4rem;
        align-items: center;
    }

    .form-container
    {
        width: 100%;
        padding: 1.5rem 0;

        display: flex;
        flex-direction: column;
        gap: 2rem;
        align-items: center;
    }

    .cards-section
    {
        width: 100%;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .admin-page-navigation
    {
        position: fixed;

        inset: 8rem 2rem auto auto;

        display: flex;
        flex-direction: column;
        gap: 0.5rem;
    }

    .forms-container
    {
        width: 100%;

        display: flex;
        flex-direction: column;
        gap: 4rem;
        align-items: center;
    }

    .form-container
    {
        width: 100%;
        padding: 1.5rem 0;

        display: flex;
        flex-direction: column;
        gap: 2rem;
        align-items: center;
    }

    .cards-section
    {
        width: 100%;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .admin-page-navigation
    {
        position: fixed;

        inset: 8rem 2rem auto auto;

        display: flex;
        flex-direction: column;
        gap: 0.5rem;
    }

    .card-form-inputs-container
    {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }

    .location-inputs
    {
        display: flex;
        gap: 1rem;
        justify-content: space-between;
        align-items: center;
    }
</style>

<div id="hubs" class="cards-section">
    <form
        onsubmit={preventDefault(handleSubmit)}
        bind:this={ form }
    >
        <div class="card-form-inputs-container">
            <Input label="Slug" id="slug" bind:value={ hubFormData[ 'slug' ] } fullWidth/>
            <InputLocalizedForm
                placeholder="Name"
                name="name"
                itemsString={ hubFormData[ 'name' ] }
                languageArray={ $languageArrayStore }
                update={ handleUpdateHubFormLocalized }
            />
            <InputLocalizedForm
                placeholder="Cover Title"
                name="title"
                itemsString={ hubFormData[ 'title' ] }
                languageArray={ $languageArrayStore }
                update={ handleUpdateHubFormLocalized }
            />
            <InputLocalizedForm
                placeholder="Heading Title"
                name="title"
                itemsString={ hubPageData[ 'title' ] }
                languageArray={ $languageArrayStore }
                update={ handleUpdatePageFormLocalized }
            />
            <InputLocalizedForm
                isMultiLine
                placeholder="Description"
                name="description"
                itemsString={ hubPageData[ 'description' ] }
                languageArray={ $languageArrayStore }
                update={ handleUpdatePageFormLocalized }
            />
            <div class="location-inputs">
                <Input
                    type="text"
                    label="Latitude"
                    id="latitude"
                    bind:value={ hubFormData[ 'latitude' ] }
                    fullWidth
                />
                <Input
                    type="text"
                    label="Longitude"
                    id="longitude"
                    bind:value={ hubFormData[ 'longitude' ] }
                    fullWidth
                />
            </div>
            <Input
                type="number"
                label="Number"
                id="number"
                bind:value={ hubFormData[ 'number' ] }
                fullWidth
            />

            <fieldset>
                <legend class="color-light-gold font-size-125 margin-bottom-100 text-transform-uppercase">Cover media</legend>
                <FileInput
                    bind:fileArray={ coverFileArray }
                    bind:isUploadingImage={ isUploadingImage }
                    fileInputName="media-path"
                    acceptedType="image/*, video/*"
                    maxFileCount={ 5 }
                    filePath={ folderPath }
                />
            </fieldset>

            <fieldset>
                <legend class="color-light-gold font-size-125 margin-bottom-100 text-transform-uppercase">Heading media</legend>
                <FileInput
                    bind:fileArray={ headingFileArray }
                    bind:isUploadingImage={ isUploadingHeadingImage }
                    fileInputName="media-path"
                    acceptedType="image/*, video/*"
                    maxFileCount={ 5 }
                    filePath={ folderPath }
                />
            </fieldset>

            <!-- <DualList
                bind:selectedListElement={ serviceIncludedElement }
                selectedListArray={ [] }
                unselectedListArray={ hubServiceArray }
                titleColumnName="title"
                dualListTitle="Included Services"
            />

            <DualList
                bind:selectedListElement={ serviceByRequestElement }
                selectedListArray={ [] }
                unselectedListArray={ hubServiceArray }
                titleColumnName="title"
                dualListTitle="Services by request"
            />

            <DualList
                bind:selectedListElement={ serviceByLocationElement }
                selectedListArray={ [] }
                unselectedListArray={ hubServiceArray }
                titleColumnName="title"
                dualListTitle="Services by Location"
            /> -->

            <fieldset style="align-self: center;">
                <p>Active</p>
                <Switch
                    bind:value={ hubFormData[ 'isActive' ] }
                />
            </fieldset>
        </div>
    </form>
</div>
